import { DEFAULT_STATE, QUALITY_LEVEL } from '../constants'
import { searchPageStore } from '../index'

/**
 * Gets the current quality value, always returns an array
 * @returns {string[]} - Array of quality levels, defaults to ["any"] if empty/undefined
 */
const getCurrentQuality = () => {
  const state = searchPageStore.getState()
  const quality = state.quality

  if (!Array.isArray(quality) || quality.length === 0) {
    return [DEFAULT_STATE.quality]
  }

  return quality
}

/**
 * Sets the quality filter
 * @param {string[]} quality - Either an array with ["any"] or an array of quality levels: ["basic", "premium", "pro"]
 */
export const setQuality = (quality) => {
  if (quality.includes(QUALITY_LEVEL.ANY)) {
    searchPageStore.setState({ quality: [QUALITY_LEVEL.ANY] })
    return
  }

  searchPageStore.setState({ quality })
}

/**
 * Adds a quality level to the array
 * @param {string} qualityLevel - Either "any" or one of: "basic", "premium", "pro"
 */
export const addQuality = (qualityLevel) => {
  if (qualityLevel === QUALITY_LEVEL.ANY) {
    searchPageStore.setState({ quality: [QUALITY_LEVEL.ANY] })
    return
  }

  const currentQuality = getCurrentQuality()

  if (currentQuality.length === 1 && currentQuality[0] === QUALITY_LEVEL.ANY) {
    searchPageStore.setState({ quality: [qualityLevel] })
    return
  }

  if (!currentQuality.includes(qualityLevel)) {
    searchPageStore.setState({ quality: [...currentQuality, qualityLevel] })
  }
}

/**
 * Removes a quality level from the array
 * @param {string} qualityLevel - One of: "basic", "premium", "pro"
 */
export const removeQuality = (qualityLevel) => {
  const currentQuality = getCurrentQuality()

  if (currentQuality.length === 1 && currentQuality[0] === QUALITY_LEVEL.ANY) {
    return
  }

  const newQuality = currentQuality.filter((q) => q !== qualityLevel)

  searchPageStore.setState({ quality: newQuality.length === 0 ? [QUALITY_LEVEL.ANY] : newQuality })
}

/**
 * Sets the content source filter
 * @param {string} contentSource - One of: "all", "ai_generated", "human_created"
 */
export const setContentSource = (contentSource) => {
  searchPageStore.setState({ contentSource })
}

/**
 * Clears the quality and content source filters
 */
export const clearQualityContent = () => {
  searchPageStore.setState({
    quality: DEFAULT_STATE.quality,
    contentSource: DEFAULT_STATE.contentSource,
  })
}
